// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1kA0i","notes":"Notes_notes__3dtjR"};